import { IconButton } from '@material-ui/core';
import styled from 'styled-components';

const StyledIconButton = styled(IconButton)`
  height: 36px;
  padding: 8px;
`;

export default StyledIconButton;
